<template>
  <div class="white-card mbh">
    <div class="is-flex is-align-items-start is-justify-content-space-between is-flex-grow-1 mb-5 ml-4">
      <p class="is-size-3 has-text-weight-bold">
        {{ $t("af:application.kyc.video_appointment.modal.delete.title") }}
      </p>
      <button
        type="button"
        class="delete"
        @click="$emit('close')"/>
    </div>
    <p class="mb-5 mx-4">
      {{ $t("af:application.kyc.video_appointment.modal.delete.content") }}
    </p>
    <button class="button mx-4" @click="deleteAppointment">
      {{ $t("af:application.kyc.video_appointment.modal.delete.buttno.confirm") }}
    </button>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";

export default {
  props: {
    appointmentId: {
      type: [Number, String],
      Required: false,
    }
  },
  methods: {
    deleteAppointment() {
      try {
        this.$store.dispatch("timeslot/deleteById", this.appointmentId);
        this.$emit('close');
        this.$buefy.toast.open({
          duration: 3000,
          message: i18n.t("af:application.kyc.video_appointment.modal.delete.toast.success"),
          position: "is-bottom",
          type: "is-success",
        });
      } catch {
        this.$buefy.toast.open({
          duration: 3000,
          message: i18n.t("af:application.kyc.video_appointment.modal.delete.toast.fail"),
          position: "is-bottom",
          type: "is-danger",
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.white-card {
  background: white;
  border-radius: 32px;
  padding: 48px;
  display: flex;
  flex-direction: column;
}

.button {
  width: fit-content;
}

@media only screen and (max-width: 792px) {
  .white-card {
    padding: 24px;
  }
}
</style>
